/**
 * Mounts the upgrade pitch once, beside the other app-wide overlays.
 *
 * A call site raises a prompt through the store and never renders a dialog of
 * its own, so the pitch cannot appear twice and its copy cannot fork.
 */
import { UpgradeDialog } from './upgrade-dialog'

export function UpgradePromptHost() {
  return <UpgradeDialog />
}
